import "./EventWorkflowTable.scss";
import ChannelSelection from "@/components/Events/ChannelSelection/ChannelSelection.vue";
import ExternEventTableActionMenu from "@/components/Events/ExternEventTableActionMenu/ExternEventTableActionMenu.vue";
import { isEqual } from "lodash";
import { getPrincipalName, getThumbnailUrl } from "@/helpers/commonHelper";
import { imports } from "@/helpers/eventHelper";

export default {
  name: "EventWorkflowTable",
  components: { ChannelSelection, ExternEventTableActionMenu },
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    pageCount: 0
  }),
  props: [
    "showPreviewImage",
    "config",
    "headers",
    "events",
    "copyEvent",
    "editEvent",
    "previewEvent",
    "deleteEvent",
    "eventCount",
    "getTypeIcon",
    "getStartTime",
    "getOrganizer",
    "getLocation",
    "getLocationCity",
    "filter",
    "isLoading",
    "getRegionality"
  ],
  methods: {
    getPrincipalName,
    getThumbnailUrl,
    nextPage() {
      const totalPages = Math.ceil(this.eventCount / this.itemsPerPage);
      if (this.page < totalPages) this.page++;
    },
    previousPage() {
      if (this.page > 1) this.page--;
    },
    previewImage(item) {
      const url = item?.pictures[0]?.url;
      return this.getThumbnailUrl(url, "events", 70, "-");
    },
    morePictures(item) {
      return item.pictures.length > 1;
    },
    getTitle(item) {
      return item.moment?.title ?? item.title;
    },
    setToLocalStorage(value) {
      localStorage.setItem("itemsPerPage", value);
    },
    editHelper(item) {
      this.$emit("editEvent", item);
    },
    deleteHelper(item) {
      if (!item.deleted) this.$emit("deleteEvent", item);
    },
    applyHelper(item) {
      if (!item.deleted) this.$emit("applyEvent", item);
    },
    declineHelper(item) {
      if (!item.deleted) this.$emit("declineEvent", item);
    },
    checkIfDateIsInPast(item) {
      const date = new Date(item.moment.from);
      const now = new Date().setHours(0, 0, 0, 0);
      if (date < now) return true;
    },
    checkIfMomentIsCancelled(item) {
      return (
        item.moment?.cancelled ??
        (item.cancelled && !this.checkIfDateIsInPast(item))
      );
    }
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    currentHeaders() {
      if (!this.showPreviewImage)
        return this.headers.filter(i => i.value !== "image");
      return this.headers;
    },
    channels() {
      if (this.config?.channels?.join("") === "web") return []; // only web-channel => hide
      return this.config?.standard_channels?.filter(c =>
        this.config?.channels?.includes(c.value)
      );
    },
    tableOptions: {
      get() {
        // eslint-disable-next-line no-unused-vars
        const { s, ...filter } = this.filter;
        return filter;
      },
      set(value) {
        if (!this.filter.isDefault) delete value.isDefault;
        if (isEqual(this.filter, value)) return;

        value.limit = value.itemsPerPage;
        const sortDirection = value?.sortDesc?.[0] ? "desc" : "asc";

        value.sort = value?.sortBy?.[0] ?? "start";
        value.direction = sortDirection;
        this.$emit("applyFilter", {
          ...this.filter,
          ...value
        });
      }
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.selectedPrincipal))
        .map(_ => _.typeId);
    }
  }
};
